<template>
    <div class="vid-main-wrapper clearfix ">
        <div v-for="(r, i) in recordings" :key="i">
          <h5><span>{{i+1}}.</span><b> {{r.meeting_name}} ({{r.links.length}} Videos)</b></h5>
          <div class="row" v-if="r.links.length > 0">
            <div v-for="(l, i) in r.links" :key="i" class="col-12 col-sm-6 col-md-4">
              <video-player class="video-js" style="border: 3px solid #fefefe;" :options="{autoplay: false, controls: true, sources: {src: l.replace(/ /, ''), type: 'application/x-mpegURl'}}"/>
            </div>
          </div> 
          <div class="row" v-else>
            <div class="col-12 text-center" style="background:#121212; border-radius:15px; padding-top:30px;">
              <p>No recorded video found for this session.</p>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import VideoPlayer from'@/components/VideoPlayer.vue';
  export default {
    name: "ChannelRecordings",
    components: {
      VideoPlayer
    },
    data(){
      return{
        recordings:[],
      }
    },
    props: ['id'],
    mounted() {
      this.getRecordingFunction()
    },
    methods: {

        getRecordingFunction: function () {
            this.$store.dispatch('getRecordings', {"channel_id": this.id } ).then(resp => {
                if (resp.data.status === "success") {
                  this.recordings = resp.data.data;
                }
            });


        }
    }
  }
</script>
<style lang="scss" scoped>
.video-js {
    position: relative !important;
    width: 100% !important;
    height: auto !important;
}
</style>
